import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import CheckIcon from "@mui/icons-material/Check";
import SimpleHelpdeskIcon from "components/shared/SimpleHelpdeskIcon";
import TextButton from "components/shared/TextButton";
import { useTranslation } from "react-i18next";

import variables from "../../../assets/styles/_variables.module.scss";
import styles from "./style.module.scss";

interface IAddButton {
    haveClickedOnButton: boolean;
    /**
     * Whether to display ? icon redirecting to doc.
     */
    useHelpdesk?: boolean;
    action: () => void;
    /**
     * Text to display while they haven't done anything (pending) or once they've clicked (clicked).
     */
    btnText: { clicked: string; pending: string };
    helpdeskLink?: string;
}

// Button of the type " + Text" that when clicked on triggers actions (display field, open modal) as seen on Term Form for advance payment.
const AddTextButton = ({ haveClickedOnButton, useHelpdesk = false, action, btnText, helpdeskLink }: IAddButton) => {
    const [t] = useTranslation();
    return (
        <div className={styles["text-button-container"]}>
            {haveClickedOnButton ? (
                <div className={styles["validated-container"]}>
                    <div className={`${styles["create-payment-chip"]} ${styles["green"]}`}>
                        <CheckIcon sx={{ width: 15, height: 15 }} />
                        {btnText.clicked}
                    </div>
                    <TextButton
                        text={t("Terms.Cancel")}
                        handleClick={action}
                        underlineOnHover
                        style={{
                            fontSize: "0.75rem",
                            fontWeight: "400",
                            color: variables["foreground"],
                        }}
                    />
                </div>
            ) : (
                <div className={`${styles["create-payment-chip"]} ${styles["blue"]}`} onClick={action}>
                    <AddOutlinedIcon sx={{ width: 15, height: 15 }} />
                    {btnText.pending}
                </div>
            )}
            {useHelpdesk && !haveClickedOnButton && <SimpleHelpdeskIcon link={helpdeskLink ?? ""} />}
        </div>
    );
};

export default AddTextButton;
